import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ style, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    {...props}
    style={{
      width: 16,
      height: 16,
      border: "1px solid #9ca3af",
      borderRadius: 4,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      background: props.checked ? "#2563eb" : "#fff",
      ...style,
    }}
  >
    <CheckboxPrimitive.Indicator>
      <Check size={14} color="#fff" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));

Checkbox.displayName = "Checkbox";

export { Checkbox };